import React, { useContext } from 'react';
import Alert from '@salesforce/design-system-react/components/alert';
import AlertContainer from '@salesforce/design-system-react/components/alert/container';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import { NotificationContext } from '../context/NotificationContext';

function AlertBanner() {
	const { notifications } = useContext(NotificationContext);

	return (
		<IconSettings iconPath="/assets/icons">
			<AlertContainer>
				{notifications.map((item) => (
					<Alert 
						dismissible
						onRequestClose={item.remove}
						labels={{
							heading: item.message
						}}
						variant={item.variant}
						key={item.timeoutId}
					/>
				))}
			</AlertContainer>
		</IconSettings>
	);
}

export default AlertBanner;